import { createSelector } from '@ngrx/store';

/**
 * Selector to get current user's role in the project
 * Checks projectMember state to find current user and their role
 */
export const selectCurrentUserProjectRole = createSelector(
  state => state['projectMember']?.data,
  state => state['auth']?.activePerson,
  (projectMembers: any[], activePerson: any) => {
    const defaultRole = {
      isProjectOwner: false,
      isProjectOwnerOrProjectManager: false,
      userRole: null,
      hasPermissionToInvite: false
    };

    if (!projectMembers?.length || !activePerson?.id) {
      return defaultRole;
    }

    const currentUserProjectMember = projectMembers.find(
      member => member.id === activePerson.id
    );

    if (!currentUserProjectMember?.authorities?.length) {
      return defaultRole;
    }

    const userRole = currentUserProjectMember.authorities[0];
    const roleKey = userRole?.key;

    const isProjectOwner = roleKey === 'person:project-owner';
    const isProjectManager = roleKey === 'person:project-manager';
    const isProjectOwnerOrProjectManager = isProjectOwner || isProjectManager;

    return {
      isProjectOwner,
      isProjectOwnerOrProjectManager,
      userRole,
      hasPermissionToInvite: isProjectOwnerOrProjectManager,
      roleKey
    };
  }
);
